import { createApi } from '@reduxjs/toolkit/query/react';
import {
  MarketplacePlanResponse,
  MarketplacePlansResponse,
  UpdateFreeMarketplacePlanRequest,
  UpdateMarketplacePlanRequest,
} from '../../types/marketplacePlans';
import { baseQueryWithReauth } from './baseQuery';

export const marketplacePlansService = createApi({
  reducerPath: 'marketplacePlansService',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['MARKETPLACE_PLANS'],
  endpoints: (builder) => ({
    getMarketplacePlans: builder.query<MarketplacePlansResponse, void>({
      query: () => ({
        url: '/marketplace-service/v1/operator/marketplace-plans',
        method: 'GET',
      }),
      providesTags: [{ type: 'MARKETPLACE_PLANS', id: 'LIST' }],
    }),

    getMarketplacePlanById: builder.query<MarketplacePlanResponse, string>({
      query: (id) => ({
        url: `/marketplace-service/v1/operator/marketplace-plans/${id}`,
        method: 'GET',
      }),
      providesTags: (_result, _error, id) => [{ type: 'MARKETPLACE_PLANS', id }],
    }),

    updateMarketplacePlan: builder.mutation<
      { payload?: unknown; success?: boolean; message?: string },
      UpdateMarketplacePlanRequest
    >({
      query: ({ id, body }) => ({
        url: `/marketplace-service/v1/operator/marketplace-plans/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: 'MARKETPLACE_PLANS', id: 'LIST' },
        { type: 'MARKETPLACE_PLANS', id },
      ],
    }),

    updateFreeMarketplacePlan: builder.mutation<
      { payload?: unknown; success?: boolean; message?: string },
      UpdateFreeMarketplacePlanRequest
    >({
      query: ({ id, body }) => ({
        url: `/marketplace-service/v1/operator/marketplace-plans/${id}/free`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: 'MARKETPLACE_PLANS', id: 'LIST' },
        { type: 'MARKETPLACE_PLANS', id },
      ],
    }),
  }),
});

export const {
  useGetMarketplacePlansQuery,
  useGetMarketplacePlanByIdQuery,
  useUpdateMarketplacePlanMutation,
  useUpdateFreeMarketplacePlanMutation,
} = marketplacePlansService;
